import React, { forwardRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import styles from "../../styles/footer.module.scss";

const Footer = forwardRef((props, ref) => {
  const socialList = [
    {
      icon: `${process.env.PUBLIC_URL}/assets/images/icons/linkedin.svg`,
      link: "https://www.linkedin.com/company/groupampersand/",
      name: "linkedin",
    },
    {
      icon: `${process.env.PUBLIC_URL}/assets/images/icons/facebook.svg`,
      link: "https://www.facebook.com/groupampersand/",
      name: "facebook",
    },
    {
      icon: `${process.env.PUBLIC_URL}/assets/images/icons/instagram.svg`,
      link: "https://www.instagram.com/group_ampersand/",
      name: "instagram",
    },
    {
      icon: `${process.env.PUBLIC_URL}/assets/images/icons/twitter.svg`,
      link: "https://twitter.com/group_ampersand",
      name: "twitter",
    },
    {
      icon: `${process.env.PUBLIC_URL}/assets/images/icons/youtube.svg`,
      link: "https://www.youtube.com/@AmpersandGroup2017",
      name: "youtube",
    },
  ];
  const currentYear = new Date().getFullYear();

  const [windowSize, setWindowSize] = useState({
    width: window.outerWidth,
    height: window.outerHeight,
  });

  const [windowSizeInner, setWindowSizeInner] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // Handler to call on window resize
    const handleResize = () => {
      setWindowSize({
        width: window.outerWidth,
        height: window.outerHeight,
      });

      setWindowSizeInner({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {props.footerCount > 0 && (
        <footer
          className="bg-white d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start py-3 px-4"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          <div className="text-danger mb-2 mb-md-0" key={0}>
            {props.footerLink[0].Type === "Link" && (
              <a
                href={props.footerLink[0].URL}
                target="_blank"
                rel="noreferrer"
                style={{
                  color: props.footerLink[0].Color || "#000000",
                  fontWeight: "600",
                }}
                className="a-text"
              >
                {props.footerLink[0].Title}
              </a>
            )}
            {props.footerLink[0].Type === "Text" && (
              <p
                style={{
                  color: props.footerLink[0].Color || "#000000",
                  fontWeight: "600",
                }}
              >
                {props.footerLink[0].Title}
              </p>
            )}
          </div>
          {props.footerLink.slice(1).map((f, index) => {
            return (
              <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-2 gap-md-4 mb-2 mb-md-0">
                {f.Type === "Link" && (
                  <a
                    href={f.URL}
                    key={index}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: f.Color || "#000000", fontWeight: "600" }}
                    className="a-text"
                  >
                    {f.Title}
                  </a>
                )}
                {f.Type === "Text" && (
                  <p
                    style={{ color: f.Color || "#000000", fontWeight: "600" }}
                    key={index}
                  >
                    {f.Title}
                  </p>
                )}
              </div>
            );
          })}
          {props.socialIcons.length > 0 && (
            <div
            className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-2"
              style={{ color: props.socialIcons[0].Color || "#000000" }}
              key={1}
            >
              <span>Follow us on</span>
              <div className="d-flex gap-2">
                <ul className={`${styles.amp_social_list}`}>
                  {props.socialIcons?.map((item, index) => {
                    let temp = socialList.filter(
                      (i) => i.name === item.Title
                    )[0];
                    if (temp.name === item.Title) {
                      return (
                        <li key={index}>
                          <Link to={item.URL} target="_blank" style={ item.Color ? { '--hover-bg-color': item.Color } : {}}>
                            <ReactSVG src={temp.icon} />
                          </Link>
                        </li>
                      );
                    }
                    return item;
                  })}
                </ul>
              </div>
            </div>
          )}
        </footer>
      )}
      {props.footerCount === 0 && (
        <footer
          className="bg-white"
          ref={ref}
          style={{
            width: "100%",
            position: "relative",
            bottom: "0",
            left: "0",
            right: "0",
            zIndex: "1",
            minHeight: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="container-fluid">
            <div className="py-2 py-md-3 py-lg-4 border-bottom border-light text-center">
              <span className="d-block fs-7 fw-semibold text-primary mb-2">
                Contact Support
              </span>
              <p className="fw-semibold">
                Vector Link:{" "}
                <a
                  href="https://vector.vibgyorhigh.com/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#000000" }}
                >
                  https://vector.vibgyorhigh.com
                </a>{" "}
                | +91 600 3000 700
              </p>
            </div>

            <div className="d-flex align-items-center justify-content-between flex-column flex-md-row gap-3 py-3 py-md-4 text-center text-md-start">
              <p className="text-gray fs-8 mb-0">
                © {currentYear} Ampersand Group. All Rights Reserved.
              </p>
              <div className="d-flex align-items-center gap-3">
                <span className="text-gray fs-8">Follow us on:</span>
                <ul className={`${styles.amp_social_list}`}>
                  {socialList?.map((item, index) => (
                    <li key={index}>
                      <Link to={item.link} target="_blank">
                        <ReactSVG src={item.icon} />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </footer>
      )}
    </>
  );
});

export default Footer;
